<script>
import ThemeSwitcher from '@/components/base-components/ThemeSwitcher.vue';
import VersionLabel from '@/components/base-components/VersionLabel.vue';
import BigPreview from '@/components/base-components/BigPreview.vue';
import PopupInfoContainer from '@/components/popups/PopupInfoContainer.vue';
import PopupContainer from '@/components/popups/PopupContainer.vue';
import LoaderScreen from '@/components/base-components/LoaderScreen.vue';
import tokenRefreshService from '@/scripts/tokenRefreshService.js';

export default {
    components: {
        ThemeSwitcher: ThemeSwitcher,
        VersionLabel: VersionLabel,
        BigPreview: BigPreview,
        PopupContainer: PopupContainer,
        PopupInfoContainer: PopupInfoContainer,
        LoaderScreen: LoaderScreen,
    },
    computed: {
        tags() {
            return this.$store.getters.TAGS;
        },
    },
    async mounted() {
        await this.$store.dispatch('LOAD_LOCAL_STORAGE');

        // Start automatic token refresh service
        tokenRefreshService.start();
    },
    beforeUnmount() {
        // Clean up token refresh service when app is destroyed
        tokenRefreshService.stop();
    },
};
</script>

<template>
    <!-- Общие компоненты -->
    <LoaderScreen />
    <PopupContainer />
    <PopupInfoContainer />
    <ThemeSwitcher />
    <VersionLabel />
    <BigPreview />
    <datalist id="tagList">
        <option v-for="(tagValue, tagIndex) in tags" :key="tagIndex">
            {{ tagValue['name'] }}
        </option>
    </datalist>

    <!-- Основная часть -->
    <router-view />
</template>
